// eslint-disable-next-line spaced-comment
import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core'
import { Router, provideRouter, withComponentInputBinding } from '@angular/router'
import { provideAnimations } from '@angular/platform-browser/animations'
import { routes } from './app.routes'
import { provideHttpClient, HttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http'
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core'
import { CustomTranslateLoader } from './loaders/translateLoader'
import { TranslationService } from '../app/shared//services/translation/translation.service'
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core'
import { DatePipe, registerLocaleData } from '@angular/common'
import { LoadingInterceptor } from './loaders/loading.interceptor'
import { provideEnvironmentNgxMask } from 'ngx-mask'
import * as Sentry from '@sentry/angular'
import localePy from '@angular/common/locales/es'
import localeEn from '@angular/common/locales/en'
import localeGt from '@angular/common/locales/es-GT'
import localeEsPy from '@angular/common/locales/es-PY'
import { getRegionLocale } from './shared/utils/language.utils'
import { CustomDateAdapter } from './shared/utils/data-formatters.util'

registerLocaleData(localeEn, 'en')
registerLocaleData(localePy, 'es')
registerLocaleData(localeGt, 'es-GT')
registerLocaleData(localeEsPy, 'es-PY')

export function initApp(translateService: TranslateService): () => Promise<{ [key: string]: string }> {
  translateService.use('en').toPromise()
  return () => translateService.get(['sales']).toPromise()
}

export function resolveInitialDateLocale(): string {
  const language = typeof window !== 'undefined' ? (window.localStorage.getItem('language') ?? 'en').toLowerCase() : 'en'
  return getRegionLocale(language)
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initApp(inject(TranslateService))
      return initializerFn()
    }),
    provideEnvironmentNgxMask(),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader,
          deps: [HttpClient, TranslationService],
        },
      }),
      MatNativeDateModule,
    ),
    DatePipe,
    { provide: MAT_DATE_LOCALE, useFactory: resolveInitialDateLocale },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
}
